import React from "react";
import { useTranslation } from "react-i18next";

import PageHeader from "../PageHeader";
import DashboardLayout from "./DashboardLayout";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const TCDashboard = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <DashboardLayout
      header={<PageHeader>{t("common.error")}</PageHeader>}
      content={
        <div>
          <p>{t("common.error")}</p>
          <Button onClick={() => history.push("/account")}>{t("signup.confirmationCta")}</Button>
        </div>
      }
      withWrapper
    />
  );
};

export default TCDashboard;
